import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import api from "@/api/stadiumcrm";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async loglist(params: any) {
    return api.loglist(params);
  }

  @Action
  async statistics(params: any) {
    return api.statistics(params);
  }
}
